import PropTypes from "prop-types";
import { motion } from "framer-motion";
import CartItem from "../CartItem";
import styles from "./CartItemList.module.css";

export function CartItemList({
  stockInfo,
  title,
  variant,
  onAddToCart,
  onSave,
  onDeleteItem,
  showTitle,
  isLoading,
}) {
  return (
    <motion.div
      key={isLoading ? "loading" : "loaded"}
      className={styles.container}
      initial={{ opacity: 0, y: -40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.28, ease: "easeOut" }}
    >
      {showTitle && <h3 className={styles.sectionTitle}>{title}</h3>}
      {stockInfo.map((info, index) => (
        <CartItem
          key={info.id || index}
          stockInfo={info}
          onDelete={() => onDeleteItem?.(info)}
          onSave={onSave ? (updated) => onSave(updated, info) : undefined}
          variant={variant}
          onAddToCart={onAddToCart ? () => onAddToCart(info) : undefined}
        />
      ))}
    </motion.div>
  );
}

CartItemList.defaultProps = {
  showTitle: true,
  isLoading: false,
};

CartItemList.propTypes = {
  title: PropTypes.string,
  onSave: PropTypes.func,
  onDeleteItem: PropTypes.func,
  variant: PropTypes.string,
  onAddToCart: PropTypes.func,
  isLoading: PropTypes.bool,
  stockInfo: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subTitle: PropTypes.string,
      memberPrice: PropTypes.number,
      retailPrice: PropTypes.number,
      itemType: PropTypes.string,
      sku: PropTypes.string,
      imageUrl: PropTypes.string,
      isThumb: PropTypes.bool,
      thirdParty: PropTypes.bool,
      creator: PropTypes.string,
    })
  ),
};

export default CartItemList;
